import { subHours as subHoursFns } from 'date-fns';

export default function subHours(date: Date, hours: number): Date {
  return subHoursFns(date, hours);
}
